export default function ReturnOrderFillMenuIcon(props) {
  return (
    <svg
      viewBox="-2 -2 28 28"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19 3C19.55 3 20.0204 3.19622 20.4121 3.58789C20.8038 3.97956 21 4.45 21 5V12.084C20.675 12.0295 20.3414 12 20.001 12C16.6873 12 14.001 14.6863 14.001 18C14.001 19.0932 14.2948 20.1173 14.8057 21H5C4.45 21 3.97956 20.8038 3.58789 20.4121C3.19622 20.0204 3 19.55 3 19V5C3 4.45 3.19622 3.97956 3.58789 3.58789C3.97956 3.19622 4.45 3 5 3H19ZM7 17H12V15H7V17ZM8 13L12 11L16 13V5H8V13Z"
        fill="currentColor"
      />
      <path
        d="M21.4 15.4L20 14L16 18L20 22L21.425 20.6L19.825 19L24 19L24 17L19.825 17L21.4 15.4Z"
        fill="currentColor"
      />
    </svg>
  );
}
